import React from "react";

export default function ConfirmedIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="13.16" height="13.16" viewBox="0 0 13.16 13.16">
  <g id="Composer_confirmed" transform="translate(0 0)">
    <rect id="Rechteck_69" data-name="Rechteck 69" width="13.16" height="13.16" rx="6.58" transform="translate(0 0)" fill="#d33843"/>
    <path id="Pfad_28" data-name="Pfad 28" d="M1515.894-1660.449l-2.312-2.671.87-.925,1.375,1.563,2.953-3.438.95.933Z" transform="translate(-1510.017 1669.813)" fill="#fffdfc"/>
  </g>
</svg>;
}